import { ChevronRight, Edit3, Leaf } from 'lucide-react';
import type { InventoryDetailItem } from '../types/inventoryDetail.types';

interface InventoryDetailSideCardsProps {
 item: InventoryDetailItem;
 canUpdate: boolean;
}

export function InventoryDetailSideCards({ item, canUpdate }: InventoryDetailSideCardsProps) {
 return (
 <div className="flex flex-col gap-4 h-full">
 {/* Supplier Block */}
 <div className="rounded-md border border-slate-200 bg-white p-4 space-y-4">
 <h3 className="text-slate-900">Nhà cung cấp</h3>
 
 <div className="flex items-center gap-3 p-2 rounded-md bg-emerald-50/30 border border-emerald-50">
 <div className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 shrink-0">
 <Leaf className="h-5 w-5" />
 </div>
 <div className="min-w-0">
 <p className="text-slate-900 truncate">{item.supplier_name || 'Vườn Ươm Thảo Nguyên'}</p>
 <p className="text-emerald-600 tracking-widest">Hợp tác lâu dài</p>
 </div>
 </div>

 <div className="space-y-3 pt-2">
 <div className="grid grid-cols-[80px_1fr] gap-2 sm:text-sm text-xs">
 <span className="text-slate-400">Mã NCC</span>
 <span className="text-slate-700">NCC0007</span>
 </div>
 <div className="grid grid-cols-[80px_1fr] gap-2 sm:text-sm text-xs">
 <span className="text-slate-400">SĐT</span>
 <span className="text-slate-700">0901 234 567</span>
 </div>
 <div className="grid grid-cols-[80px_1fr] gap-2 sm:text-sm text-xs">
 <span className="text-slate-400">Email</span>
 <span className="text-slate-700 truncate">vuonthaonguyen@gmail.com</span>
 </div>
 </div>

 <button className="w-full mt-2 flex items-center justify-between rounded-md border border-slate-100 p-3 sm:text-sm text-xs text-slate-700 hover:bg-slate-50 transition-colors">
 <span>Xem chi tiết nhà cung cấp</span>
 <ChevronRight className="h-4 w-4 text-slate-300" />
 </button>
 </div>

 {/* Note Block */}
 <div className="rounded-md border border-slate-200 bg-white p-4 flex-1 relative group">
 <div className="flex items-center justify-between mb-3">
 <h3 className="text-slate-900 sm:text-sm text-xs tracking-widest opacity-50">Ghi chú</h3>
 {canUpdate && (
 <button className="text-slate-300 hover:text-emerald-600 transition-colors">
 <Edit3 className="h-3 w-3" />
 </button>
 )}
 </div>
 <p className="sm:text-sm text-xs text-slate-600 leading-relaxed italic">
 {item.note || 'Ưu tiên nhập từ nhà cung cấp này vì chất lượng gingốcây ổn định và vận chuyển nhanh.'}
 </p>
 </div>
 </div>
 );
}


